import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { directionsUrl, locations } from '../data/site';

export const DirectionsChooser = ({ children, prefix = '' }) => (
  <Dialog>
    <DialogTrigger asChild>{children}</DialogTrigger>
    <DialogContent className="directions-dialog" data-testid={`${prefix}directions-dialog`}>
      <DialogHeader>
        <DialogTitle data-testid={`${prefix}directions-title`}>Find your shop.</DialogTitle>
        <DialogDescription data-testid={`${prefix}directions-description`}>Performance Lube 915 · El Paso, Texas</DialogDescription>
      </DialogHeader>
      {locations.map((location) => <a key={location.id} className="directions-option" href={directionsUrl(location)} target="_blank" rel="noopener noreferrer"
        data-testid={`${prefix}directions-${location.id}`}>
        <MapPin size={22} aria-hidden="true" /><span><strong>{location.name}</strong><span>{location.address}<br />{location.city}</span></span><ArrowUpRight size={20} aria-hidden="true" />
      </a>)}
    </DialogContent>
  </Dialog>
);